/**
 * 1フレーム待ってからコールバックを実行する
 */
export const nextTick = (cb: () => any) => {
	return new Promise<any>(resolve => {
		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				resolve(cb())
			})
		})
	})
}